<script lang="ts" setup>
import { Button } from '@brighterly/lib-lumee-ui'

import { useAssessmentTestStore } from '@stores/assessment-test'

import { useAssessmentTestControl } from '@hooks/assessments/assessment-test-control.hook'

import qaConfig from '@config/qa.json'

defineOptions({
  name: 'SectionAssessmentTestFooter',
})

const assessmentTestStore = useAssessmentTestStore()

const {
  setSkipStep,
  setNextStep,
  setSubmitAnswers,
} = useAssessmentTestControl()

const questionNumber = computed(() => assessmentTestStore.getCurrentQuestionIndex + 1)
const questionsTotal = computed(() => assessmentTestStore.getQuestionsTotal)

</script>

<template>
  <div class="assessment-footer">
    <template v-if="questionNumber !== questionsTotal">
      <Button
        view="tertiary"
        :data-qa="qaConfig.attributes.assessmentSkip"
        text="Skip"
        @click="setSkipStep"
      />
      <Button
        :data-qa="qaConfig.attributes.assessmentNext"
        :disabled="!assessmentTestStore.getCurrentAnswer"
        text="Next question"
        fill
        @click="setNextStep"
      />
    </template>
    <Button
      v-else
      :data-qa="qaConfig.attributes.assessmentSubmit"
      :disabled="!assessmentTestStore.getCurrentAnswer"
      text="Submit my answers"
      fill
      @click="setSubmitAnswers"
    />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Sections/Assessment/SectionAssessmentTestFooter.scss" />
